document.addEventListener("DOMContentLoaded", () => {
  const navbar = document.querySelector(".navbar");
  const header = document.querySelector(".header");

  if (!header) {
    navbar.classList.add("navbar--scrolled");
    return;
  }

  const onScroll = () => {
    const headerBottom = header.offsetHeight;
    if (window.scrollY > headerBottom) {
      navbar.classList.add("navbar--scrolled");
    } else {
      navbar.classList.remove("navbar--scrolled");
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
});
